import React from "react";
import { Alert, Stack } from "@mui/material";

interface MeetingErrorPanelProps {
  message: string;
}

const MeetingErrorPanel: React.FC<MeetingErrorPanelProps> = ({
  message,
}) => {
  return (
    <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          minHeight: "100vh",
          background:
            "linear-gradient(0deg,rgb(222, 238, 253),rgb(172, 220, 226))",
        }}
      >
        <Alert
          severity="error"
          sx={{
            fontSize: "1.25rem",
            justifyContent: "center",
            border: "1px solid",
            borderColor: "error.main",
            backgroundColor: "rgba(255,255,255,0.7)",
            "& .MuiAlert-icon": { fontSize: "2rem" },
            "& .MuiAlert-message": { textAlign: "center" },
          }}
        >
          {message}
        </Alert>
      </Stack>
  );
};

export default MeetingErrorPanel;
